import { gql } from '@apollo/client';

export default gql`
  mutation putOnHold($bookingReference: String!) {
    putOnHold(bookingReference: $bookingReference) {
      reference
      status
    }
  }
`;
